export const isPasswordValid = (password) => {
  password = password.trim()
  if (password.length < 8 || password.length >= 60) {
    return false
  }
  // Deve conter letras minúsculas
  if (!(/[a-z]/g.test(password))) {
    return false
  }
  // Deve conter letras maiúsculas
  if (!(/[A-Z]/g.test(password))) {
    return false
  }
  // Deve conter números
  if (!(/[0-9]/g.test(password))) {
    return false
  }
  // Deve conter símbolos
  if (!(/\W/g.test(password))) {
    return false
  }
  return true
}

export const isEmailValid = (email) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(email)
}

export const isCepValid = (cep) => {
  const regex = /^[0-9]{5}-[\d]{3}$/
  return regex.test(cep)
}

export const isValidDocumentCPF = (cpf) => {
  if (cpf === undefined || cpf === null) return false

  cpf = cpf.replace(/[^\d]+/g, '')

  if (cpf === '') return false

  if (cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999') {
    return false
  }

  let add = 0
  let i
  let rev

  for (i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i)
  }

  rev = 11 - (add % 11)

  if (rev === 10 || rev === 11) {
    rev = 0
  }

  if (rev !== parseInt(cpf.charAt(9))) {
    return false
  }
  add = 0

  for (i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i)
  }

  rev = 11 - (add % 11)

  if (rev === 10 || rev === 11) {
    rev = 0
  }

  if (rev !== parseInt(cpf.charAt(10))) {
    return false
  }

  return true
}
